module.exports = __webpack_public_path__ + "media/images/method-blik-be97f8ed952c7fad39588d9ccded1887.png";